<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <datos-familiares></datos-familiares>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import DatosFamiliares from '@/components/forms/DatosFamiliares'
  export default {
    name: 'FamiliarPage',
    components: {DatosFamiliares}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/information/FamiliarPage.vue